var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-swipe',{staticClass:"my-swipe",attrs:{"autoplay":3000,"indicator-color":"white"}},_vm._l((_vm.banner),function(item){return _c('van-swipe-item',{key:item.src},[_c('a',{attrs:{"href":item.url,"target":item.target}},[_c('img',{staticClass:"banner-top",attrs:{"src":item.src}})])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }